// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Banco Master — COMPE 243 */
export const BancoMaster = createBankIcon({
  name: "Banco Master",
  slug: "bancomaster",
  compe: "243",
  color: "#0d2a5c",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#0d2a5c;fill-opacity:1\"\n     id=\"bancomaster_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(18.5239,19.8368) scale(0.52506)\">\n    <path d=\"m90.618 35.11h-9.3645l-21.624 50.458-24.753-46.365h-1.4821l-28.649 52.974h6.7622l8.7972-16.046 13.808-23.798 6.3482 10.465 2.2376 3.9658 2.2405 3.8442 3.7719 6.9648 7.9027 14.604h6.9444l9.4456-20.33 2.7732-5.9632 10.161-26.2 10.569 26.2 0.44578 1.0305 0.81055 1.8903 1.3634 3.0424 9.5382 20.33h6.545zm-3.6682-12.333h-1.485l-3.4216 7.3845h8.2848z\" style=\"fill:#c7c6c5\" />\n  </g>",
});
